import { useConfig } from "$global-providers/config-provider/provider";
import { TERRITORY } from "$routes/_lib/constants";
import { createContext, useContext } from "react";
import kenyaLocalities from "./kenya-localities.json";
import liberiaLocalities from "./liberia-localities.json";
import nigeriaLocalities from "./nigeria-localities.json";
import pakistanLocalities from "./pakistan-localities.json";

const territoryLocalityMap = {
  [TERRITORY.KENYA]: kenyaLocalities,
  [TERRITORY.NIGERIA]: nigeriaLocalities,
  [TERRITORY.PAKISTAN]: pakistanLocalities,
  [TERRITORY.LIBERIA]: liberiaLocalities,
};

export const LocalitiesContext = createContext<{
  localities: Record<string, Record<string, Array<string>>>;
  error?: boolean;
}>({
  error: false,
  localities: {},
});

export const useLocalitiesContext = () => useContext(LocalitiesContext);

// TODO: Each locality json file is ~20kb. We should be lazy loading these!
// The whole context is **only** used by the <RHFAddressFields /> component.
// So we should probably simplify and stop this being a context entirely.
export const LocalitiesProvider: FCwC = ({ children }) => {
  const { territory } = useConfig();

  return (
    <LocalitiesContext.Provider
      value={{ error: false, localities: territoryLocalityMap[territory] }}
    >
      {children}
    </LocalitiesContext.Provider>
  );
};
